import { WelcomeStyle } from "./styles/WelcomeStyle";
import { Link, useNavigate } from "react-router-dom";
import { ReadWellLogo, ReadWellMain } from "../assets/images";
import AppLogo from "../components/AppLogo";

const Welcome = (props) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(-1);
  };

  return (
      <WelcomeStyle>
        <nav onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <AppLogo
              containerStyle="logo-container"
              textStyle="logo-text"
          />
        </nav>
        <div className="container page">
          {/** Info */}
          <div className="info">
            <h1>Dashboard</h1>
            <p>Manage and monitor users and books. Keep track of key activities and performance</p>
            <Link to="/register" className="btn btn-hero">Login/Register</Link>
          </div>
          <ReadWellMain className="main-img"/>
        </div>
      </WelcomeStyle>
  );
};
export default Welcome;